import styled, { css } from 'styled-components';
import { Link } from 'react-scroll';
import { Link as Glink } from 'gatsby';

export const Box = styled.div`
  width: 100%;
  max-width: 1180px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;
  padding: 0 20px;
  box-sizing: border-box;

  .hamburgerBtn {
    display: none;
  }

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    padding: 0;

    /* & > img {
      width: 30%;
      margin-bottom: 30px;
    } */
  }
`;

export const Container = styled.span`
  display: inline;

  .navWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .bm-burger-button {
    position: fixed;
    width: 36px;
    height: 30px;
    left: 36px;
    top: 36px;
  }

  /* Styling of overlay */
  .bm-overlay {
    ${({ isOpen }) =>
      isOpen &&
      css`
        top: 0 !important;
      `} background: rgba(0, 0, 0, 0.3);
  }
`;

export const TextLinks = styled.div`
  display: flex !important;
  flex-direction: ${({ mobile }) => (mobile ? 'column' : 'row')};
  justify-content: space-between;
  font-family: 'BDRmono';
  font-size: 0.75em;
  box-sizing: border-box;

  @media (max-width: 750px) {
    margin-top: 10px;
    width: 100vw;
    padding: 0 20px;
    box-sizing: border-box;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start !important;
  }

  ${({ mobile }) =>
    mobile &&
    css`
      display: flex !important;
      width: auto !important;
      justify-content: flex-start;
      align-items: center;
      outline: none;
      margin: 0 auto 30px;

      a {
        margin-bottom: 10px;

        &:hover {
          color: #fff;
        }
      }
    `};
`;

export const MainNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 750px) {
    justify-content: center;
    flex-direction: column;
  }
`;

export const GLink = styled(Glink)`
  color: #000;
  text-transform: uppercase;
  text-decoration: none;
  transition: all 180ms ease-out;
  font-size: 1.4em;
  font-family: 'GT America';
  font-weight: bold;
  font-style: italic;
  margin-left: 25px;
  @media (max-width: 750px) {
    margin-left: 10px;
    margin-right: 10px;
    &:first-child {
      margin-right: 0;
    }
  }

  &:hover {
    color: #9ce856;
  }
`;

export const NLink = styled(Link)`
  color: #000;
  text-transform: uppercase;
  text-decoration: none;
  transition: all 180ms ease-out;
  font-size: 1.4em;
  font-family: 'GT America';
  font-weight: bold;
  font-style: italic;
  margin-left: 25px;
  @media (max-width: 750px) {
    margin-left: 15px;
    margin-right: 15px;
  }

  &:hover {
    color: #9ce856;
  }
`;

export const ALink = styled.a`
  color: #000;
  text-transform: uppercase;
  text-decoration: none;
  transition: all 180ms ease-out;
  font-size: 1.4em;
  font-family: 'GT America';
  font-weight: bold;
  font-style: italic;
  margin-left: 25px;
  padding-right: 15px;
  @media (max-width: 750px) {
    margin-left: 15px;
    margin-right: 15px;
  }

  &:hover {
    color: #9ce856;
  }
`;

export const Social = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 225px;
  margin-top: 20px;

  @media (max-width: 750px) {
    width: 100%;
    justify-content: center;
    a {
      margin: 0 25px;
    }
  }

  a {
    margin: 0 10px;
    transition: opacity 180ms ease-out;
    &:hover {
      opacity: 0.7;
    }
  }

  ${({ mobile }) =>
    mobile &&
    css`
      display: flex !important;
      width: 80%;
      margin: 20px auto 0;
    `};
`;
